import "../../../../css/Recruitment/RadioButton.css";
import "../../../../css/Recruitment/FormField.css";
import { useState, useEffect, useMemo, useCallback } from "react";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../Utils/submissionListener";
import Tooltip from "../../../DesignSystem/Tooltip/Tooltip";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/Circle Info - Small (filled).svg";

const toArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);

const RadioButtonGrid = ({
  options = [],
  tooltips = [],
  columns = 2,
  name,
  value,
  onChange,
  error,
  /** ✅ if true, emits [option]; if false, emits "option" */
  emitArray = true,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(() => getIsSubmitted());

  useEffect(() => {
    const removeListener = addSubmissionListener((v) => setIsSubmitted(!!v));
    setIsSubmitted(getIsSubmitted());
    return () => removeListener();
  }, []);

  const selectedArr = useMemo(() => toArray(value), [value]);

  const isChecked = useCallback(
    (option) => selectedArr.includes(option),
    [selectedArr],
  );

  const handleRadioChange = (event) => {
    if (isSubmitted) return;

    const selectedValue = event.target.value;

    onChange?.({
      target: {
        name,
        value: emitArray ? [selectedValue] : selectedValue,
      },
    });
  };

  return (
    <div
      className={`radio-grid ${error ? "error" : ""}`}
      style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}
    >
      {options.map((option, index) => (
        <div key={`${name}-${option}-${index}`} className="radio-with-tooltip">
          <label className="radio-option">
            <input
              type="radio"
              name={name}
              value={option}
              onChange={handleRadioChange}
              checked={isChecked(option)}
              disabled={isSubmitted}
            />
            <span className="custom-radio" />
            <div className="Content">{option}</div>
          </label>

          {tooltips?.[index] ? (
            <Tooltip content={tooltips[index]} position="top">
              <InfoIcon className="tooltip-icon" />
            </Tooltip>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default RadioButtonGrid;
